// An email address as the client takes one before it is sent: something, an
// @, and a domain with a dot in it, no spaces and none of the separators a
// list of them is split on. The relay's own check where it has one is
// mail.ParseAddress with a dot in the domain (files.go, review_requests.go);
// this is the same shape, said where it is typed rather than refused after
// (byj-1wv.51.13). One place for it: a review request's addresses and the
// Admin page's person fields alike.

export const addressLike = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;

/** Whether `s`, trimmed, is a whole email address. */
export const isAddress = (s: string) => addressLike.test(s.trim());
